import { defineMessages } from 'react-intl';

const messages = defineMessages({
  cancelled: {
    id: 'activity-notification.cancelled',
    defaultMessage: 'cancelled',
  },
  rescheduled: {
    id: 'activity-notification.rescheduled',
    defaultMessage: 'rescheduled',
  },
  declined: {
    id: 'activity-notification.declined',
    defaultMessage: 'declined',
  },
  scheduled: {
    id: 'activity-notification.scheduled',
    defaultMessage: 'scheduled',
  },
  confirmed: {
    id: 'activity-notification.confirmed',
    defaultMessage: 'confirmed',
  },
  reassigned: {
    id: 'activity-notification.reassigned',
    defaultMessage: 'reassigned',
  },
  collegeFair: {
    id: 'activity-notification.collegeFair',
    defaultMessage: 'College Fair',
  },
  visit: {
    id: 'activity-notification.visit',
    defaultMessage: 'Visit',
  },
  changeVisit: {
    id: 'activity-notification.changeVisit',
    defaultMessage: ' has changed',
  },
  virtual: {
    id: 'activity-notification.virtual',
    defaultMessage: 'virtual',
  },
  inPerson: {
    id: 'activity-notification.inPerson',
    defaultMessage: 'in-person',
  },
  virtualVisit: {
    id: 'activity-notification.virtualVisit',
    defaultMessage: 'virtual visit',
  },
  inPersonVisit: {
    id: 'activity-notification.inPersonVisit',
    defaultMessage: 'in-person visit',
  },
  from1: {
    id: 'activity-notification.from1',
    defaultMessage: ' a ',
  },
  from2: {
    id: 'activity-notification.from2',
    defaultMessage: ' an ',
  },
  to1: {
    id: 'activity-notification.to1',
    defaultMessage: ' to a ',
  },
  to2: {
    id: 'activity-notification.to2',
    defaultMessage: ' to an ',
  },
  dots: {
    id: 'activity-notification.dots',
    defaultMessage: ':',
  },
  dismiss: {
    id: 'activity-notification.dismiss',
    defaultMessage: 'DISMISS NOTIFICATION',
  },
  addUrl: {
    id: 'activity-notification.addUrl`',
    defaultMessage: 'ADD VISIT URL',
  },
  errorDismiss: {
    id: 'activity-notification.errorDismiss',
    defaultMessage: 'Something went wrong when dismissing this notification.',
  },
  aVisitForYou: {
    id: 'activity-notification.aVisitForYou',
    defaultMessage: 'a {event} for you',
  },
  a: {
    id: 'activity-notification.a',
    defaultMessage: 'a',
  },
  an: {
    id: 'activity-notification.an',
    defaultMessage: 'an',
  },
  your: {
    id: 'activity-notification.your',
    defaultMessage: 'your',
  },
  forYou: {
    id: 'activity-notification.forYou',
    defaultMessage: 'for you',
  },
  this: {
    id: 'activity-notification.this',
    defaultMessage: 'this',
  },
  their: {
    id: 'activity-notification.their',
    defaultMessage: 'their',
  },
  request: {
    id: 'activity-notification.request',
    defaultMessage: 'request',
  },
  appointment: {
    id: 'activity-notification.appointment',
    defaultMessage: 'appointment',
  },
  dateTime: {
    id: 'activity-notification.dateTime',
    defaultMessage: '{date} at {time}',
  },
  viewFullDetails: {
    id: 'activity-notification.viewFullDetails',
    defaultMessage: 'View Full Details',
  },
  lessThanASecond: {
    id: 'activity-notification.lessThanASecond',
    defaultMessage: 'less than a second ago',
  },
  seconds: {
    id: 'activity-notification.seconds',
    defaultMessage: '{seconds, plural, one {# second} other {# seconds}} ago',
  },
  minutes: {
    id: 'activity-notification.minutes',
    defaultMessage: '{minutes, plural, one {# minute} other {# minutes}} ago',
  },
  hours: {
    id: 'activity-notification.hours',
    defaultMessage: '{hours, plural, one {# hour} other {# hours}} ago',
  },
  days: {
    id: 'activity-notification.days',
    defaultMessage: '{days} days ago',
  },
  yesterday: {
    id: 'activity-notification.yesterday',
    defaultMessage: 'yesterday',
  },
  theyIncludedAMessage: {
    id: 'activity-notification.theyIncludedAMessage',
    defaultMessage: 'They included a message:',
  },
});

export default messages;
